import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

import {vnApp_sentinelbi} from "../vnApp_sentinelbi";
import { sidebarMenu_template } from "./sidebarMenu_template";

declare var ko: any;



export class usersEdit_template extends vnTemplate{

    public sidebarMenu: sidebarMenu_template;

    protected getTemplateHtml(): string{

        return `

        <div class="page-header">
            <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
            <h2 class="title-page">User</h2>
        </div>
        <div class="nav-page-container">
            <div class="nav-page-grid">
                <div class="nav-page-sidebar" data-bind="visible: $data.sidebarMenu.isVisible()">
                    ` + this.sidebarMenu.getHtmlBuild() + `
                </div>
                <div class="nav-page-content">
                    <div class="w-form w-form-large">
                        <div class="form-header">
                            <input id="user-id" data-bind="value: idUser" type="hidden">
                            <!-- ko ifnot: $data.idUser() -->
                                <h3 class="form-title icon i-user-add">Add User</h3>
                            <!-- /ko -->

                            <!-- ko if: $data.idUser() -->
                                <h3 class="form-title icon i-user-add">edit User</h3>
                            <!-- /ko -->

                            <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
                        </div>
                        <div class="w-form-body">
                            <div class="form-body">
                                <strong class="form-sub-title">personal info</strong>
                                <div class="form-group">
                                    <legend class="form-legend">active</legend>
                                    <div class="form-check-inline width-auto">
                                        <input type="radio" name="isActive" id="active_yes" value="1" data-bind="checked: isActive, disable: disableActive" />
                                        <label class="form-label" for="active_yes">Yes</label>
                                    </div>
                                    <div class="form-check-inline width-auto">
                                        <input type="radio" name="isActive" id="active_no" value="0" data-bind="checked: isActive, disable: disableActive" />
                                        <label class="form-label" for="active_no">No</label>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="firstName" class="form-label">First Name</label>
                                    <input id="firstName" data-bind="value: firstName, disable: disabledName" type="text" class="input-text">
                                </div>
                                <div class="form-group">
                                    <label for="lastName" class="form-label">Last Name</label>
                                    <input id="lastName" data-bind="value: lastName, disable: disabledName" type="text" class="input-text">
                                </div>
                                <div class="form-group">
                                    <label for="loginName" class="form-label">User Name</label>
                                    <input id="loginName" data-bind="value: loginName, disable: disabledUsername" type="text" class="input-text">
                                </div>
                                <div class="form-group">
                                    <label for="email" class="form-label">Email</label>
                                    <input id="email" data-bind="value: email, event: { blur: onBlurEmail }, disable: disabledEmail" type="email" class="input-text">
                                </div>

                                <!-- ko if: $data.idUser() -->
                                <div class="form-group">
                                    <input id="change-password" type="checkbox" data-bind="checked: isChangingPassword, disable: disabledPassword">
                                    <label for="change-password" class="form-label icon i-check">Change sentinelPro Password?</label>
                                </div>
                                <!-- /ko -->

                                <!-- ko if: showPasswordField() -->
                                    <div class="form-group-password is-open" id="form-group-password">
                                        <div class="form-group">

                                            <!-- ko if: $data.idUser() -->
                                                <label class="form-label" for="password">New Password</label>
                                            <!-- /ko -->

                                            <!-- ko ifnot: $data.idUser() -->
                                                <label class="form-label" for="password">Password</label>
                                            <!-- /ko -->

                                            <input id="password" data-bind="value: password, disable: disabledPassword" type="password" class="input-pass">
                                        </div>
                                        <div class="form-group">

                                            <!-- ko if: $data.idUser() -->
                                                <label class="form-label" for="passwordConfirmation">New Password Confirmation</label>
                                            <!-- /ko -->

                                            <!-- ko ifnot: $data.idUser() -->
                                                <label class="form-label" for="passwordConfirmation">Password Confirmation</label>
                                            <!-- /ko -->

                                            <input id="passwordConfirmation" data-bind="value: passwordConfirmation, disable: disabledPassword" type="password" class="input-pass">
                                        </div>
                                    </div>
                                <!-- /ko -->

                    <!-- ko if: canManageRememberMe -->
                    <div class="form-group">
                        <input id="remember-me-allowed" type="checkbox" data-bind="checked: rememberMeAllowed">
                        <label for="remember-me-allowed" class="form-label icon i-check">Allow this user to use Remember Me</label>
                        <p>Applies after the user's next complete login. Turning this off removes remembered access.</p>
                    </div>
                    <!-- /ko -->

                                <!-- ko if: false -->
                                    <div class="form-group">
                                        <label class="form-label label-oneline inputfile-label" for="profile-pic">Profile Picture</label>
                                        <div id="dropzone">
                                            <div id="my-drop-zone" data-bind="css: disabledProfileImage() ? '' : 'dropzone needsclick dz-clickable'" class=""></div>
                                                <input id="profile-pic" data-bind="value: pictureUrl" type="hidden">
                                            </div>
                                    </div>
                                <!-- /ko -->

                            </div>
                            <div class="form-body">
                                <strong class="form-sub-title">personal info</strong>
                                <div data-bind="visible: !hasOwnerRole()" class="form-group">
                                    <legend class="form-legend">Roles</legend>
                                    <div data-bind="foreach: roles" >
                                        <div class="form-check-inline">
                                            <input data-bind="value: id, checked: $parent.selectedRoles, attr:{id:id}, disable: $parent.isRoleDisabled(id)" type="checkbox">
                                            <label data-bind="text: name, attr:{for:id}" class="form-label icon i-check">Administrator</label>
                                        </div>
                                    </div>
                                </div>

                                <div data-bind="visible: !hasAdminRole() && !hasOwnerRole()" class="form-group">

                                    <legend class="form-legend">Property Access</legend>
                                    <div data-bind="foreach: brands">
                                        <div class="form-check-inline">
                                            <input data-bind="value: id, checked: $parent.selectedBrands, attr:{id: 'brand_' + id}, disable: $parent.isBrandDisabled(id)" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: name, attr:{for: 'brand_' + id}"></label>
                                        </div>
                                    </div>
                                    <!-- ko if: $data.permissions()['user_edit_advanced'].write && !disabledBrandButtons() -->
                                        <div class="margin-top">
                                            <button class="btn border" type="button" id="select_all" data-bind="event: { click: onSelectAllAction}, disable: !$data.permissions()['user_edit_advanced'].write">Select All</button>
                                            <button class="btn border" type="button" id="deselect_all" data-bind="event: { click: onDeselectAllAction}, disable: !$data.permissions()['user_edit_advanced'].write">Deselect All</button>
                                        </div>
                                    <!-- /ko -->

                                </div>

                                <div data-bind="visible: hasAdminRole() || hasOwnerRole()" class="form-group">
                                    <p class="form-text">
                                        User is granted access to all of the Projects.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                            <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save User</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer class="default-footer">
            <span class="logo-short"></span>
            <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
            <span>|</span>
            <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
        </footer>


            `;
    }

    protected initPartial():void{
        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('account-users');
    }

    protected getTemplateName(): string{
        return "usersEdit-form-template";
    }

    protected getMainElementClasses(): Array<string>{
        return ["page-content"];
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        let viewModel = {    idUser: ko.observable("")
                    ,firstName: ko.observable("")
                    ,lastName: ko.observable("")
                    ,loginName: ko.observable("")
                    ,email: ko.observable("")
                    ,pictureUrl: ko.observable(null)
                    ,password: ko.observable("")
                    ,roles: ko.observableArray([])
                    ,brands: ko.observableArray([])
                    ,selectedRoles: ko.observableArray([])
                    ,selectedBrands: ko.observableArray([])
                    ,passwordConfirmation: ko.observable("")
                    ,oldPassword: ko.observable("")
                    ,canManageRememberMe: ko.observable(false)
                    ,rememberMeAllowed: ko.observable(false)
                    ,rememberMeCsrfToken: ko.observable("")
                    ,isActive: ko.observable("1")
                    ,isAdmin: ko.observable(false)
                    ,isOwner: ko.observable(false)
                    ,isPM: ko.observable(false)
                    ,isGM: ko.observable(false)
                    ,disableActive: ko.observable(true)
                    ,disabledName: ko.observable(true)
                    ,disabledEmail: ko.observable(true)
                    ,disabledUsername: ko.observable(true)
                    ,disabledPassword: ko.observable(true)
                    ,disabledProfileImage: ko.observable(true)
                    ,disabledRoles: ko.observableArray([])
                    ,authorizedBrands: ko.observableArray([])
                    ,disabledBrands: ko.observableArray([])
                    ,isChangingPassword: ko.observable(false)
                    ,hasAdminRole: ko.observable(false)
                    ,hasOwnerRole: ko.observable(false)
                    ,permissions: ko.observableArray(this.initPermissions(['user_edit_self', 'user_edit_advanced', 'user_edit_pm_config', 'user_edit_gm_config', 'user_edit_admin_config']))
                    ,twoFactorMethod: ko.observable('email')
                    ,showPasswordField: ko.observable(false)
                    ,disabledBrandButtons: ko.observable(false)
                    ,isRoleDisabled: function(data){return ko.computed(function () { return huit_neuf_this.isRoleDisabled(data);}, this)}
                    ,isBrandDisabled: function(data){return ko.computed(function () { return huit_neuf_this.isBrandDisabled(data);}, this)}
                    ,onClickSave: function(data, event){ huit_neuf_this.onClickSave(); }
                    ,onClickCancel: function(data, event){ huit_neuf_this.onClickCancel(); }
                    ,onBlurEmail: function(data, event){ huit_neuf_this.onBlurEmail(); }
                    ,onSelectAllAction: function () { huit_neuf_this.onSelectAllAction();}
                    ,onDeselectAllAction: function () { huit_neuf_this.onDeselectAllAction();}
                    ,openSidebar: function() {

                        huit_neuf_this.openSidebar();
                    },
                };

        viewModel.selectedRoles.subscribe(function(checked) {
            huit_neuf_this.validateBrands();
        }, viewModel);

        viewModel.isChangingPassword.subscribe(function(checked) {
            huit_neuf_this.displayChangePassword(checked);
        }, viewModel);

        return viewModel;
    }

    public setSideMenuPermissionsData(data){

        this.sidebarMenu.setData(data);
    }

    private openSidebar(){

        this.sidebarMenu.setSidebarToggle(true);
    }

    protected validateBrands(){

        let checked = this.getTemplateViewModel().selectedRoles();
        if ((checked.indexOf(vnApp_sentinelbi.ROLE_ADMINISTRATOR) >= 0)) {
            this.getTemplateViewModel().hasAdminRole(true);
            this.setSelectedBrands([]);

            let disabledBrands = [];
            for(let b of this.getTemplateViewModel().brands()){
                disabledBrands.push(b.id);
            }
            //this.getTemplateViewModel().disabledBrands(disabledBrands);

        }else if ((checked.indexOf(vnApp_sentinelbi.ROLE_OWNER) >= 0)) {

            this.getTemplateViewModel().hasOwnerRole(true);
        }else {
            this.getTemplateViewModel().hasAdminRole(false);
            this.getTemplateViewModel().hasOwnerRole(false);
            //this.getTemplateViewModel().disabledBrands([]);
        }

    }

    protected setDisabledBrandsForBrandManager(disabledBrands) {

        this.getTemplateViewModel().disabledBrands(disabledBrands.map(b => b.id));
    }


    protected onDeselectAllAction(){

        let disabledIdsSet = new Set(this.getTemplateViewModel().disabledBrands());
        let selectedBrandIds = this.getTemplateViewModel().selectedBrands() as any[];
        this.getTemplateViewModel().selectedBrands(selectedBrandIds.filter(id => disabledIdsSet.has(id)));
    }

    protected onSelectAllAction(){
        
        let disabledIdsSet = new Set(this.getTemplateViewModel().disabledBrands());
        let selectedIdsSet = new Set(this.getTemplateViewModel().selectedBrands());
        let allBrands = this.getTemplateViewModel().brands();

        for(let brand of allBrands){
            if(!disabledIdsSet.has(brand.id)){
                selectedIdsSet.add(brand.id);
            }
        }

        this.getTemplateViewModel().selectedBrands(Array.from(selectedIdsSet));
    }

    public setSelectedRoles(selectedRoles : Array<{id: number}>){
        let roles = [];
        for(let r of selectedRoles){

            roles.push(r.id);
        }
        this.getTemplateViewModel().selectedRoles(roles);
        this.validateBrands();
    }

    public setSelectedBrands(selectedBrands : Array<{id: number}>){
        let brands = [];
        for(let c of selectedBrands){
            brands.push(c.id);
        }
        this.getTemplateViewModel().selectedBrands(brands);
    }

    protected onClickSave() {
        this.caller.saveEditUser();
    }

    protected isRoleDisabled(data: number) {
        let disabled: Array<number> = this.getTemplateViewModel().disabledRoles();

        for(let r of disabled){
            if(data == r){
                return true;
            }
        }
        return false;
    }

    protected isBrandDisabled(data: number){

        let disabled: Array<number> = this.getTemplateViewModel().disabledBrands();
        for(let c of disabled){
            if(data == c){
                return true;
            }
        }
        return false;
    }

    protected onClickCancel(){
        this.caller.cancelEditUser();
    }

    protected onBlurEmail(){

    }

    protected displayChangePassword(checked){

        if(checked){
            this.getTemplateViewModel().showPasswordField(true);
        }else{
            this.getTemplateViewModel().showPasswordField(false);
            this.getTemplateViewModel().password("");
            this.getTemplateViewModel().oldPassword("");
            this.getTemplateViewModel().passwordConfirmation("");
        }

    }

    public setupForm(vnApp_sentinelbi, allRoles, allBrands, userRoles, userBrands, loggedUserId, user){

        if(user.vnAppUser.id !== undefined && user.vnAppUser.id !== null){

            for(let r of user.vnAppUser.roles){

                if (r.id == vnApp_sentinelbi.ROLE_ADMINISTRATOR) {

                    this.getTemplateViewModel().isAdmin(true);
                }

                if (r.id == vnApp_sentinelbi.ROLE_OWNER) {

                    this.getTemplateViewModel().isOwner(true);
                }

                if (r.id == vnApp_sentinelbi.ROLE_PROPERTY_MANAGER) {

                    this.getTemplateViewModel().isGM(true);
                }
            }
        }

        let permissions = this.getTemplateViewModel().permissions();

        if (user.id == null && permissions['user_edit_advanced'].write) {

            this.getTemplateViewModel().disabledName(false);
            this.getTemplateViewModel().disabledEmail(false);
            this.getTemplateViewModel().disabledUsername(false);
            this.getTemplateViewModel().disabledPassword(false);
            this.getTemplateViewModel().disabledProfileImage(false);
            this.getTemplateViewModel().disableActive(false);
        }else {

            if ((user.id == loggedUserId && permissions['user_edit_self'].write) || permissions['user_edit_advanced'].write) {

                this.getTemplateViewModel().disabledName(false);
                this.getTemplateViewModel().disabledEmail(false);
                this.getTemplateViewModel().disabledUsername(false);
                this.getTemplateViewModel().disabledProfileImage(false);
            }

            if (permissions['user_edit_advanced'].write) {

                this.getTemplateViewModel().disableActive(false);
            }

            let isRestrictedRole = (this.getTemplateViewModel().isPM() || this.getTemplateViewModel().isGM() || this.getTemplateViewModel().isOwner() || this.getTemplateViewModel().isAdmin())
            let isAllowedToEditRestrictedRole = (
                permissions['user_edit_advanced'].write && (
                    (this.getTemplateViewModel().isPM() && permissions['user_edit_pm_config'].write)
                    || (this.getTemplateViewModel().isGM() && permissions['user_edit_gm_config'].write)
                    || (this.getTemplateViewModel().isAdmin() && permissions['user_edit_admin_config'].write)
                ));

            if ((user.id == loggedUserId) || (!isRestrictedRole && permissions['user_edit_advanced'].write) || isAllowedToEditRestrictedRole){

                this.getTemplateViewModel().disabledPassword(false);
            }
        }

        let disabledRoles = [];
        if (permissions['user_edit_advanced'].write && (user.id != loggedUserId)) {

            if (!permissions['user_edit_gm_config'].write){

                disabledRoles.push(vnApp_sentinelbi.ROLE_PROPERTY_MANAGER);
            }

            if (!permissions['user_edit_admin_config'].write){

                disabledRoles.push(vnApp_sentinelbi.ROLE_ADMINISTRATOR);
            }
        }else {

            for (let role of allRoles) {

                disabledRoles.push(role.id);
            }

            this.getTemplateViewModel().disabledBrandButtons(true);
        }
        this.getTemplateViewModel().disabledRoles(disabledRoles);

        let disabledBrands = [];
        if ((user.id == loggedUserId) || !permissions['user_edit_advanced'].write || !permissions['user_edit_brands'].write) {

            for (let brand of allBrands) {

                disabledBrands.push(brand.id);
            }
        }

        this.getTemplateViewModel().disabledBrands(disabledBrands);
        this.getTemplateViewModel().roles(allRoles);
        this.getTemplateViewModel().brands(allBrands);

    }

    public setShowPasswordField(value) {

        this.getTemplateViewModel().showPasswordField(value);
    }

    public setPersistentLoginSettings(settings){

        const model = this.getTemplateViewModel();
        model.canManageRememberMe(!!settings && settings.canManage === true);
        model.rememberMeAllowed(!!settings && settings.allowed === true);
        model.rememberMeCsrfToken(settings && typeof settings.csrfToken === 'string' ? settings.csrfToken : '');
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/usersEdit_template.ts